// utils
import anime from 'animejs'
import {
  createAnimation
} from '@/assets/js/utils/createAnimation'
import {
  characterWalk
} from '@/assets/js/utils/characterWalk'
import {
  createRotateAnimation
} from '@/assets/js/utils/createRotateAnimation'
import {
  createWalkAnimation
} from '@/assets/js/utils/createWalkAnimation'

const joeAnimations = () => {
  return {
    wave(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#joe_right_arm',
            rotate: '25deg',
            easing: 'linear',
            duration: 350,
            begin: options.begin,
          })
          .add({
            targets: '#joe_right_arm_hand',
            rotate: '90deg',
            easing: 'linear',
            duration: 350,
          })
          .add({
            targets: '#joe_right_arm_hand',
            rotate: '100deg',
            easing: 'linear',
            duration: 350,
          })
          .add({
            targets: '#joe_right_arm_hand',
            rotate: '90deg',
            easing: 'linear',
            duration: 350,
          })
          .add({
            targets: '#joe_right_arm_hand',
            rotate: '100deg',
            easing: 'linear',
            duration: 350,
          })
          .add({
            targets: '#joe_right_arm_hand',
            rotate: '90deg',
            easing: 'linear',
            duration: 350,
          })
          .add({
            targets: '#joe_right_arm_hand',
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            delay: 150
          })
          .add({
            targets: '#joe_right_arm',
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            complete: options.complete
          })
      }, options, this)()
    },
    rotate(options) {
      return createAnimation(createRotateAnimation("#joe_outer"), options, this)()
    },
    walk(options) {
      return createAnimation(createWalkAnimation('#joe'), options, this)()
    }
  }
}

export {
  joeAnimations
}



// WEBPACK FOOTER //
// ./src/components/module_6/js/joeAnimations.js